import { updateOrganizations } from './updatePlanOrganizationThunk';
export default updateOrganizations;
